import React, { FC } from 'react';

import { customTheme } from 'theme';

import { PrimaryButton, PrimaryButtonProps } from 'components/DataEntry';
import { ActionIcon, ArrowDownIcon, DownIcon } from 'components/Icons';
import { IMenuItemProps, Menu } from 'components/Overlay';

interface Props extends PrimaryButtonProps {
  menuItems: IMenuItemProps[];
  label?: string | React.ReactNode;
}

export const OutlinedMenuButton: FC<Props> = props => {
  const { menuItems, label, children, ...rest } = props;
  return (
    <Menu
      menuItems={menuItems}
      buttonLabel={
        <PrimaryButton
          _hover={{}}
          _focus={{}}
          _active={{}}
          bg="none"
          border="1px solid"
          fontSize="16px"
          borderColor={customTheme.colors.gray['100']}
          color={customTheme.colors.gray['300']}
          iconColor="#000"
          px={2}
          //iconSpacing={1}
          leftIcon={<ActionIcon p={0.5}/>}
          rightIcon={<DownIcon p={1} />}
          {...rest}
        >
          {label ?? children}
        </PrimaryButton>
      }
    />
  );
};
